import Vue from 'vue';
import VueI18n from 'vue-i18n';
//import en from './en';
//import hu from './hu';
import data from './data.json';
const en = {};
const hu = {};

Object.keys(data.en).map(key => {
    const [p, s] = key.split('.');
    if (!en[p]) en[p] = {};
    en[p][s] = data.en[key];
});

Object.keys(data.hu).map(key => {
    const [p, s] = key.split('.');
    if (!hu[p]) hu[p] = {};
    hu[p][s] = data.hu[key];
});

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
        hu,
    },
});

export const supportedLocales = () => ['en', 'hu'];

export default i18n;
